import { secondsToMinutes } from 'date-fns'

import { TileImage } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'

import { articleCategoryPath } from 'libs/paths'
import Image from 'components/LegacyImage'
import Link from 'components/Link'

import { formattedDate } from '../../../components/utils'

const Intro = () => {
  const { article } = useStaticData()
  const { t } = useTranslation('@mc/next')

  return (
    <section className='container mc-pt-10'>
      <div className='row' data-testid='article-hero'>
        <div className='col-lg-8 offset-lg-1 offset-sm-none col-sm-12'>
          <Link
            className='mc-text--bold mc-text--uppercase mc-opacity--muted mc-text-h7'
            href={articleCategoryPath(article.category.slug)}
            passHref
          >
            {article.category.name}
          </Link>
          <h1 className='mc-text-h1 mc-my-2'>{article.title}</h1>
          <p className='mc-mb-1'>
            {t('article.hero.author', {
              author: article.author,
            })}
          </p>
          <p className='mc-opacity--muted'>
            {t('article.hero.lastUpdated', {
              time: formattedDate(article.updatedAt),
              minutes: secondsToMinutes(article.readTime),
            })}
          </p>
        </div>
        <div className='col-lg-8 offset-lg-1 offset-sm-none col-sm-12'>
          <div
            data-testid='article-hero-description'
            className='mc-text-large mc-mb-10 highlight-shareable'
            dangerouslySetInnerHTML={{ __html: article.description }}
          />
          {article.heroImage?.url && (
            <TileImage
              image={
                <Image
                  alt=''
                  className='mc-mb-3'
                  height={338}
                  priority
                  src={article.heroImage.url}
                  width={789}
                />
              }
            />
          )}
        </div>
      </div>
    </section>
  )
}

export default Intro
